export default "__VITE_ASSET__2yEXbMan__"